import { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import { getRandomHeadlineImage, getHeadlineImagePath } from '../../utils/headlineImages';
import SEO from '../../utils/SEO';
import GoogleAdSquare from '../googleads/GoogleAdSquare';

export default function CreateOrJoinRoom() {
  const navigate = useNavigate();
  const [randomImage, setRandomImage] = useState<string>("");

  useEffect(() => {
    setRandomImage(getRandomHeadlineImage());
  }, []);

  const handleCreateRoom = () => {
    navigate('/app/create');
  };

  const handleJoinRoom = () => {
    navigate('/app/join');
  };

  const handleBack = () => {
    window.location.replace('/');
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <SEO 
        title="Play Spyfall Online"
        description="Start playing Spyfall with friends! Create a new room or join an existing one. A thrilling social deduction game where players try to identify the spy."
        keywords="spyfall game, create room, join room, online multiplayer, social deduction"
      />
      {/* Google AdSense Ad */}
      {/* <GoogleAdSquare /> */}

      <div className="max-w-md mx-auto px-4 py-16">
        {/* Image Card */}
        <div className="relative w-64 h-64 bg-gradient-to-br from-red-900 to-red-700 rounded-lg shadow-lg p-6 flex flex-col items-center justify-center text-center border-2 border-red-500 overflow-hidden mb-8 mx-auto">
          <img
            src={getHeadlineImagePath(randomImage)}
            alt="Room Selection"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
          <div className="absolute inset-[3px] bg-gray-900/20 rounded-md flex flex-col items-center justify-center p-4">
            <div className="text-red-500 font-bold text-sm mb-2"></div>
            <div className="text-xl font-bold"></div>
          </div>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Join or Create Room</h1>
          <p className="text-gray-400">Start playing Spyfall with friends!</p>
        </div>

        <div className="space-y-4">
          <Button
            className="w-full bg-red-500 hover:bg-red-600"
            onClick={handleCreateRoom}
          >
            Create New Room
          </Button>

          <Button
            className="w-full border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
            variant="outline"
            onClick={handleJoinRoom}
          >
            Join Existing Room
          </Button>
        </div>


        <Button
          variant="ghost"
          className="w-full mt-8 text-gray-400 hover:text-white"
          onClick={handleBack}
        >
          Back to Home
        </Button>

        {/* Google AdSense Ad (Bottom) */}
        <div className="mt-6">
          <GoogleAdSquare />
        </div>
      </div>
    </div>
  );
} 